import { useState } from 'react';
import {
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  FormControl,
  Tabs,
  Tab,
} from '@mui/material';
import { FORM_LABELS, DIALOG, BUTTONS, REPORT_TYPES } from '../constants';
import { SimpleForm } from 'react-admin';
import { ReportFormProvider, useReportForm } from './ReportFormContext';
import StandardReportForm from './StandardReportForm';
import { MasterReportDialog } from './MasterReportDialog';

const ReportDialogs = () => {
  const {
    openConfirmCreateDialog,
    setOpenConfirmCreateDialog,
    reportType,
    notify,
    handleConfirmCreateReport,
    openDialog,
    setOpenDialog,
    confirmGenerateForAll,
    submitReport,
    openTpaDialog,
    setOpenTpaDialog,
    openMasterDialog,
    setOpenMasterDialog,
    handleMasterSubmit,
    months,
  } = useReportForm();

  return (
    <>
      <Dialog open={openConfirmCreateDialog} onClose={() => setOpenConfirmCreateDialog(false)}>
        <DialogTitle>
          {reportType === REPORT_TYPES.ASSIST_REVIEW
            ? DIALOG.CONFIRM_ASSIST_REPORT_TITLE
            : DIALOG.CONFIRM_PA_REPORT_TITLE}
        </DialogTitle>
        <DialogContent>
          <p>
            {reportType === REPORT_TYPES.ASSIST_REVIEW
              ? DIALOG.CONFIRM_ASSIST_REPORT_MESSAGE
              : DIALOG.CONFIRM_PA_REPORT_MESSAGE}
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmCreateDialog(false);
              notify('notifications.REPORT_NOT_CREATED', { type: 'info' });
            }}
            color="primary"
          >
            {BUTTONS.CANCEL}
          </Button>
          <Button onClick={handleConfirmCreateReport} autoFocus variant="contained">
            {BUTTONS.CONFIRM}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>{DIALOG.GENERATE_REPORT_TITLE_CLIENTS}</DialogTitle>
        <DialogContent>
          <p>{DIALOG.GENERATE_REPORT_MESSAGE_CLIENT}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            {BUTTONS.CANCEL}
          </Button>
          <Button
            onClick={(e) => confirmGenerateForAll(setOpenDialog, submitReport)}
            color="primary"
            autoFocus
            variant="contained"
          >
            {BUTTONS.CONFIRM_GENERATE_REPORT}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openTpaDialog} onClose={() => setOpenTpaDialog(false)}>
        <DialogTitle>{DIALOG.GENERATE_REPORT_TITLE_TPA}</DialogTitle>
        <DialogContent>
          <p>{DIALOG.GENERATE_REPORT_MESSAGE_TPA}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenTpaDialog(false)} color="primary">
            {BUTTONS.CANCEL}
          </Button>
          <Button
            onClick={() => {
              setOpenTpaDialog(false);
              submitReport([]);
            }}
            color="primary"
            autoFocus
            variant="contained"
          >
            {BUTTONS.CONFIRM_GENERATE_REPORT}
          </Button>
        </DialogActions>
      </Dialog>
      <MasterReportDialog
        open={openMasterDialog}
        onClose={() => setOpenMasterDialog(false)}
        onConfirm={handleMasterSubmit}
        months={months}
      />
    </>
  );
};

const ReportToggle = () => {
  const { isMedSubReport, setIsMedSubReport } = useReportForm();

  return (
    <FormControl component="fieldset" sx={{ mb: 2, width: '100%', textAlign: 'center' }}>
      <RadioGroup
        row
        value={isMedSubReport.toString()}
        onChange={(e) => setIsMedSubReport(e.target.value === 'true')}
        sx={{ justifyContent: 'center' }}
      >
        <FormControlLabel value="false" control={<Radio size="small" />} label="Standard Date Range" />
        <FormControlLabel
          value="true"
          control={<Radio size="small" />}
          label="Medicaid Subrogation (by Uploaded Claims)"
        />
      </RadioGroup>
    </FormControl>
  );
};

const Reports = () => {
  return (
    <ReportFormProvider>
      <SimpleForm toolbar={false}>
        <Box sx={{ width: 1200, mx: 'auto', mt: 5, p: 3, border: '1px solid #ddd', borderRadius: 2 }}>
          <Typography variant="h5" sx={{ mb: 2, textAlign: 'center' }}>
            {FORM_LABELS.GENERATE_REPORT}
          </Typography>
          <ReportToggle />
          <StandardReportForm />
        </Box>

        <ReportDialogs />
      </SimpleForm>
    </ReportFormProvider>
  );
};

export default Reports;
